<div
  [id]="tabId"
  [hidden]="!isActive()"
  role="tabpanel"
  [attr.aria-hidden]="!isActive()"
  [attr.aria-labelledby]="tabId + '-tab'"
>
  <ng-content />
</div>
